import { render, staticRenderFns } from "./configuration-local-accounting-billable-rate-grid-copy-modal.vue?vue&type=template&id=ec671214&"
import script from "./configuration-local-accounting-billable-rate-grid-copy-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-rate-grid-copy-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports